// extracted by mini-css-extract-plugin
export default {"DetailsUserForm":"SignUpPage_DetailsUserForm__D1g+v"};